import ExportDeudaPorDniPage from "./ExportDeudaPorDniPage";

export {ExportDeudaPorDniPage}
export default ExportDeudaPorDniPage
